import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {SurveyFilterUIModel} from '../../../models/survey/survey.model';

@Component({
  selector: 'app-input-number-custom',
  templateUrl: './input-number-custom.component.html',
  styleUrls: ['./input-number-custom.component.less']
})
export class InputNumberCustomComponent implements OnInit, OnDestroy {

  inputValue: string;
  showError = false;
  questionOperatorValue: string;
  showUpdateRangePopup = false;
  from: number;
  to: number;
  @Input() eventValidate: Observable<number[]>;
  @Input() eventValidateSubscription: any;
  @Input() id: number;

  @Input()
  get questionFilterOperator() {
    return this.questionOperatorValue;
  }

  set questionFilterOperator(value) {
    this.questionOperatorValue = value;
  }

  @Output()
  inputChange = new EventEmitter<string>();

  @Input()
  get input() {
    return this.inputValue;
  }

  set input(val) {
    this.inputValue = val;
    if (val && val.length && val.indexOf('From') > -1) {
      this.updateNumberRangeLabel(val);
    }
  }

  constructor() {
  }

  ngOnInit() {
    if (this.eventValidate) {
      this.eventValidateSubscription = this.eventValidate.subscribe((listId) => {
        if (listId.includes(this.id)) {
          this.showError = this.inputValue === '' || this.inputValue === null;
        } else {
          this.showError = false;
        }
      });
    }
  }

  updateNumberRangeLabel(val?) {
    if (val && val.length > 0) {
      const items = val.split(' ');
      this.from = items[1];
      this.to = items[3];
    }
    this.inputValue = `From ${this.from} to ${this.to}`;
  }

  onInputChange(event: any) {
    if (this.eventValidate) {
      this.showError = event === '' || event === null;
    }
    this.inputChange.emit(this.inputValue);
  }

  ngOnDestroy(): void {
    if (this.eventValidateSubscription) {
      this.eventValidateSubscription.unsubscribe();
    }
  }

  isBetweenOperator() {
    return this.questionOperatorValue === 'Between';
  }

  onClickItem() {
    this.showUpdateRangePopup = true;
  }

  updateNumberRange(value) {
    if (value) {
      this.showUpdateRangePopup = false;
      this.from = value.split(';')[0];
      this.to = value.split(';')[1];
      this.updateNumberRangeLabel();
      this.inputChange.emit(this.inputValue);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/input-number-custom/input-number-custom.component.ts